module.exports = __webpack_public_path__ + "static/img/beta_bg_white_08.1b7c1293.svg";